import * as React from 'react';
import { useState } from 'react';
import { css } from '@emotion/core';
import { RaterLevel } from '../models';
import LocalDiv from '../../../../localization/LocalDiv';
import { FLEX_COLUMN } from '../../../../layout/flexBox';
import { lastCommaFirstLocal } from '../module';
import LocalSelect from '../../../../localization/LocalSelect';
import LocalDropdownOption from '../../../../localization/LocalDropdownOption';
import { Str } from '../../../../localization/translationKeys';
import LocalBtn from '../../../../localization/LocalBtn';
import { btnStyle } from '../../../../forms/styles/button';
import { COLORS } from '../../../../globalStyle/colors';
import { SELECT } from '../../../../forms/styles/select';
import Msg from '../../../../localization/Msg';
import { DirectoryRaterViewModelProps } from './props';


const styles = {
  root:              css`
    background-color: ${COLORS.LIGHTEST_GREY};
  `,
  raterInfo:         css`
    &[dir="ltr"] {
      text-align: left;
    }

    &[dir="rtl"] {
      text-align: right;
    }
  `,
  dropdownContainer: {
    root:     css``,
    dropdown: css`
      border-color: ${COLORS.WHITE};
    `,
  },
  addBtnContainer:   {
    root:   css`
      &[dir="ltr"] {
        text-align: right;
      }

      &[dir="rtl"] {
        text-align: left;
      }
    `,
    button: css`
      padding-left: 12px;
      padding-right: 12px;
    `,
  },
};


type Props = DirectoryRaterViewModelProps;


const renderRaterLevelOptions = (levels: RaterLevel[]) => levels.map(
  level => (
    <LocalDropdownOption
      key={level.surveyLevelId}
      value={level.surveyLevelId}
      labelKey={''}
      labelText={level.fullName}
    />
  ),
);


/**
 * RaterSearchTableRow: a component that renders a form enabling the user to set a rater level for the associated rater
 * and add them to the project.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RaterSearchTableRow: React.FC<Props> = props => {
  const [levelId, setLevelId] = useState<number | undefined>(undefined);

  const onClickSubmitBtn = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    props.setAddedRater(levelId!);
  };

  return (
    <tr css={[styles.root]}>
      <td>
        <LocalDiv css={[FLEX_COLUMN, styles.raterInfo]}>
          <Msg str='' defaultMsg={lastCommaFirstLocal(props.dir, props.rater) || '---'} />
          <Msg str='' defaultMsg={props.rater.email} />
        </LocalDiv>
      </td>
      <td>
        <LocalDiv css={styles.dropdownContainer.root}>
          <LocalSelect
            css={[SELECT, styles.dropdownContainer.dropdown, !levelId && css`color: ${COLORS.FIELD_GREY};`]}
            onChange={event => setLevelId(+event.target.value)}
            value={levelId}
          >
            {
              !levelId && (
                <LocalDropdownOption labelKey={Str.SelectOne} hidden={true} value='' />
              )
            }
            {renderRaterLevelOptions(props.raterLevels)}
          </LocalSelect>
        </LocalDiv>
      </td>
      <td>
        <LocalDiv css={styles.addBtnContainer.root}>
          <LocalBtn
            str={Str.Add}
            css={[btnStyle.primary(COLORS.DARK_GREY), styles.addBtnContainer.button]}
            disabled={!levelId}
            onClick={onClickSubmitBtn}
          />
        </LocalDiv>
      </td>
    </tr>
  );
};

export default RaterSearchTableRow;
